module.exports = __webpack_public_path__ + "static/media/bedwellLogo.3a384fa1.svg";